import { localStorageAdapter } from "commons/LocalStorageAdapter/LocalStorageAdapter";

export default class UpdateRecentLivestreaming {
  constructor({ element }) {
    this.element = element
    this.livestreamingId = element.dataset.livestreamingId
    this.localStorageAdapter = localStorageAdapter()
    this.livestreaming = {id: parseInt(this.livestreamingId), type: 'livestreaming'}
    this._storageSize = 20
    this.storageName = 'recent_livestreamings'
  }

  init() {
    let recentLivestreamings = this.getRecentLivestreamings()
    let updatedRecentLivestreamings = this.prependCurrentLivestreaming(recentLivestreamings)

    this.saveToLocalStorage(updatedRecentLivestreamings)
  }

  getRecentLivestreamings() {
    let recentLivestreamings = this.localStorageAdapter.getItem(this.storageName)

    return recentLivestreamings !== null? JSON.parse(recentLivestreamings) : []
  }

  prependCurrentLivestreaming(livestreamings) {
    let recentLivestreamings = livestreamings.filter(livestreaming => livestreaming.id != this.livestreaming.id)
                                             .slice(0, this.storageSize() - 1)

    recentLivestreamings.unshift(this.livestreaming)
    return recentLivestreamings
  }

  saveToLocalStorage(livestreamings){
    this.localStorageAdapter.setItem(this.storageName, JSON.stringify(livestreamings));
  }

  storageSize() {
    return this._storageSize
  }
}


